import { useEffect } from "react";

import { useQuery } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { MdMessage } from "react-icons/md";
import { Link } from "react-router-dom";

import { messagesPath } from "@path/messages_paths";

import { useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

import { COUNT_MESSAGES_QUERY, COUNT_MESSAGES_SUBSCRIPTION } from "./queries";
import type { CountMessagesQueryResultInterface } from "./types";

export default function Messages() {
  const session = useAppSelector(sessionSelector);
  const { t } = useTranslation(["translation", "messages"]);

  const { data, subscribeToMore } = useQuery<CountMessagesQueryResultInterface>(COUNT_MESSAGES_QUERY);

  useEffect(() => {
    return subscribeToMore({
      document: COUNT_MESSAGES_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => subscriptionData.data || prev,
    });
  }, [subscribeToMore]);

  const unread = parseInt(data?.countMessages?.unread || "0", 10) || 0;

  if (unread <= 0) {
    return null;
  }

  const label = unread >= 100 ? "99+" : unread.toString();

  return (
    <Link
      className="TT-unseen-messages"
      to={messagesPath(session)}
      title={t("translation:sidebar.messages", { count: unread })}
    >
      <MdMessage />
      {unread > 0 && <span className="TT-top-bar-badge">{label}</span>}
    </Link>
  );
}
